module.exports = __webpack_public_path__ + "img/case04.bcee9190.png";